import { h, Component, Fragment } from "preact";
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';


/*
 * Tool di comodità per non ripetere il codice necessario a stampare il messaggio d'errore
 * in caso non siano stati trovati risultati per la ricerca selezionata
 */
export let EmptyRecordsMessage = () => <div class="text-center text-lg text-gray-500 pb-3">
	<Trans>Non ci sono record da mostrare</Trans>
</div>;

/**
 * Tabella con rihe e celle. Usare l'attributo "first" sulla prima cella di ogni riga per dare il bordo colorato
*/
export let Table = ({children}) => (<table class="w-full table-auto border border-l-0">{children}</table>);
export let CustomTable = ({children, ...props}) => (<table {...props}>{children}</table>);
export let HRow = ({children, ...props}) => (<tr {...props} class={(props.class || '')}>{children}</tr>);
export let Row = ({children, ...props}) => (<tr {...props} class={props.class || ''}>{children}</tr>);

export let Cell = (props = ({children, first, action, colspan, borderColor})) =>
		(<td colspan={props.colspan || 1} class={(props.first ? ' border-l-4' : '')+(props.action ? ' text-center' : '')+(props['class'] ? ' '+props['class'] : '')} style={props.first ? "border-left-color: "+(props.borderColor || '#38b2ac')+";" : ''}>{props.children}</td>);

export let HCell = ({children, first = false, action = false, ...props}) =>
		(<th class={"px-2 py-1 border-b"+(first ? ' border-l-4' : '')+(action ? ' text-center' : '')+(props['class'] ? ' '+props['class'] : '')}>{children}</th>);

/**
 * Currency: Formatta un importo in font monospace e lo colora di rosso se negativo
*/
export let Currency = ({currency, amount}) =>
		(<div class="block w-full leading-none font-mono flex"><span class="text-xs inline-block">{currency}</span> <span class={`text-right pr-4 flex-1 ${amount < 0 ? 'text-red-600' : ''}`}>{parseFloat(amount).toFixed(2)}</span></div>);

/**
 * ActionButton: Bottone con bordo colorato e sfondo bianco (in genere)
*/
export let ActionButton = (props) => {
	let {children, label, color = "blue", textColor="white"} = props;
	return <a href="javascript:void(0);"
		class={`inline-block text-center border rounded py-1 border-${color}-500 text-${color}-500 bg-${textColor} hover:bg-${color}-500 hover:text-${textColor} px-2 ${props['class'] || ''}`}
		onClick={props.onClick}
	>
		{children || label}
	</a>;
}

/**
 * FilledButton: Bottone con colori opposti ad actionbutton
*/
export let FilledButton = (props) => {
	let {children, label, color = "blue", textColor="white"} = props;
	return <a
		href="javascript:void(0);"
		class={`inline-block text-center border rounded py-1 border-${color}-500 text-${textColor} bg-${color}-500 hover:bg-${textColor} hover:text-${color}-500 px-2 ${props['class'] || ''}`}
		onClick={props.onClick}
	>
	{children || label}
	</a>;
}

/**
 * FiltersRow: Sezione della pagina con tutti i filtri. Contiene diversi "FiltersGroup"
*/
export let FiltersRow = ({children, ...props}) => (
	<div class={"w-full pb-1 sm:flex"+(props['class'] ? ' '+props['class'] : '')}>
		{children}
	</div>)
export let FiltersGroup = ({children}) => (<div class="sm:flex-1 px-2 flex flex-wrap">{children}</div>);
/**
 * InputFilter: input con stile predefinito
*/
export let InputFilter = (props) => (<input {...props} class={"px-2 py-1 rounded border bg-white flex-1 "+(props['class'])} />);
/**
 * InputFilter: input con stile predefinito
*/
export let SelectFilter = (props) => (<select {...props} class={"px-2 py-1 rounded border bg-white flex-1 "+(props['class'])} />);

/**
 * Pannello che contiene la tabella e forse anche la paginazione.
*/
export let Panel = ({children, ...props}) => <div class={"block py-2 px-3 center bg-white border-t-2 mx-4 border-[color:var(--main-color)] "+(props['class']||'')}>{children}</div>;
export let PanelRow = ({children}) => <div class="py-4 mx-auto">{children}</div>;


export let InputRow = ({children, label, inputclass, boxclass, ...props}) => <div class={boxclass || 'py-1 px-2 sm:w-1/2 w-full'}>
	<div><div>{children || label}</div><InputFilter autocomplete="off" {...props} class={!!inputclass? inputclass : "w-full"} /></div>
</div>;

export let SelectRow = ({children, label, boxclass, ...props}) => <div class={boxclass || 'py-1 px-2 w-1/2'}>
	<div><div>{label}</div><select class={"w-full p-2 rounded border bg-white flex-1 "+(props['class'] || '')} {...props}>{children}</select></div>
</div>;

/*
 * Calcola il numero di pagine usando un metodo stile limit di mysql
 * Il vantaggio è che in questo modo nei controller che necessitano di paginazione si salvano
 * informazioni che è possibile usare direttamente per un .slice() evitando ulteriori calcoli.
 * Guarda il file "/src/templates/bonus-visualizza-campagne.jsx" per un esempio
 */
export let PaginationCurrentPageCalc = (pageindex, pagelength) => (pageindex + pagelength) / pagelength;
export let PaginationTotalPagesCalc = (datalength, pagelength) => Math.ceil(datalength / pagelength);

export let Pagination = ({pages = null, currentPage = 1, onNavigation, isLastPage = false}) => {
	const minPageNumber = Math.max(1, currentPage - (isLastPage ? 6 : 3));
	const maxPageNumber = pages !== null? pages+1 : Math.min(minPageNumber + 7, isLastPage ? currentPage + 1 : Infinity);
	const pageButtons = [
		<a
			class={`pagination-link ${minPageNumber!=currentPage? '' : 'selected'}`}
			href="javascript:void(0);"
			onClick={e => onNavigation(1)}
		>
			1{minPageNumber > 1 ? '...' : ''}
		</a>
	];

	for (let i = minPageNumber+1; i < maxPageNumber; i++) {
		pageButtons.push(
			<a class={`pagination-link ${i!=currentPage? '' : 'selected'}`}
				href="javascript:void(0);"
				onClick={e => onNavigation(i)}
			>
				{i}
			</a>
		);
	}

	return <div class="block py-1 text-center text-sm leading-none">
		<div class="flex justify-center">
			<a class="pagination-prev" href="javascript:void(0);" onClick={e => onNavigation(Math.max(1, currentPage-1))}><Trans>Previous</Trans></a>
			{pageButtons}
			<a class="pagination-next" href="javascript:void(0);" onClick={e => onNavigation(currentPage+1)} disabled={isLastPage}><Trans>Next</Trans></a>
		</div>
	</div>;
};

export let PaginationV2 = ({pages, currentPage, onNavigation, pagebreaks = 15, pagechunks = 4, pagecenterchunk = 5}) => {
    let output = [];

    if (pages <= pagebreaks) {

        for (let i = 0; i < pages; ++i) {
            output.push(
                <a href="javascript:void(0);"
                   onClick={e => onNavigation(i + 1)}
                   class={'pagination-link' + (currentPage === i + 1? ' selected' : '')}
                >
                    {i + 1}
                </a>
            );
        }

    } else {

        for (let i = 0; i < pagechunks; ++i) {
            output.push(
                <a href="javascript:void(0);"
                   onClick={e => onNavigation(i + 1)}
                   class={'pagination-link' + (currentPage === i + 1? ' selected' : '')}
                >
                    {i + 1}
                </a>
            );
        }

        if (pages > pagechunks*2) {
            output.push(<span class="mx-1 text-gray-400 leading-10">…</span>);

            let lowcenterchunk = Math.ceil(pagecenterchunk/2);
            let highcenterchunk = Math.floor(pagecenterchunk/2);

            let minprint;
            let maxprint;

            if (currentPage + highcenterchunk >= pages - pagechunks) {
                minprint = pages - pagechunks - pagecenterchunk;
                maxprint = pages - pagechunks;
            } else if (currentPage-lowcenterchunk < pagechunks) {
                minprint = pagechunks;
                maxprint = pagechunks + pagecenterchunk;
            } else {
                minprint = currentPage - lowcenterchunk;
                maxprint = currentPage + highcenterchunk;
            }

            if (pages >= 25) {
                output.push(
                    <a href="javascript:void(0);"
                       onClick={e => onNavigation(currentPage - 10 < 1 ? 1 : currentPage - 10)}
                       class="pagination-link rounded-l border-r-0"
                    >
                        «
                    </a>
                );
            }

            for (let i = minprint; i < maxprint; ++i) {
                output.push(
                    <a href="javascript:void(0);"
                       onClick={e => onNavigation(i + 1)}
                       class={'pagination-link' + (currentPage === i + 1 ? ' selected' : '')}
                    >
                        {i + 1}
                    </a>
                );
            }

            if (pages >= 25) {
                output.push(
                    <a href="javascript:void(0);"
                       onClick={e => onNavigation(currentPage + 10 > pages ? pages : currentPage + 10)}
                       class="pagination-link rounded-r border-l-0"
                    >
                        »
                    </a>
                );
            }

            output.push(<span class="mx-1 text-gray-400 leading-10">…</span>);
        }

        for (let i = pages-pagechunks; i < pages; ++i) {
            output.push(
                <a href="javascript:void(0);"
                   onClick={e => onNavigation(i + 1)}
                   class={'pagination-link' + (currentPage === i + 1 ? ' selected' : '')}>
                    {i + 1}
                </a>
            );
        }

    }

    return <div class="block py-1 text-center text-sm leading-none">
        <div class="flex justify-center items-start">
            <a href="javascript:void(0);"
               onClick={e => onNavigation(currentPage - 1 < 1? 1 : currentPage - 1)}
               class="pagination-prev"
            >
                <Trans>Previous</Trans>
            </a>
            {output}
            <a href="javascript:void(0);"
               onClick={e => onNavigation(currentPage + 1 > pages? pages : currentPage + 1)}
               class="pagination-next"
            >
                <Trans>Next</Trans>
            </a>
        </div>
    </div>;
};

//> Eof